<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <table-search
        :style="{ float: 'right' }"
        add-text="新增任务"
		    @onExport="onExport"
        :addbtn-is-show="$store.state.user.role === 1"
        @onSearch="onSearch"
        @editAndAdd="editAndAdd"
		    @onChangecompany="onChangecompany"
      />
    </div>
    <div class="global-table-container">
      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: total => `共${total}条`,
        }"
        @change="changePage"
      >
        <template
          slot="status"
          slot-scope="status"
        >
          {{ status | agreement($store.state.user.role) }}
        </template>
        <template
          slot="operation"
          slot-scope="text, record"
        >
          <popconfirm-button
            v-show="record.status === 0 && $role === 1"
            text="提交"
            alert-title="确定提交任务？"
            @onDelete="() => onConfirm(record)"
          />
          <a-divider
            v-show="record.status === 0 && $role === 1"
            type="vertical"
          />
          <span
            v-for="(operationName, index) in record.operations"
            :key="operationName"
          >
            <a
              href="javascript:;"
              @click="() => action(record)"
            >{{
              operationName
            }}</a>
            <a-divider
              v-if="index !== record.operations.length - 1"
              type="vertical"
            />
          </span>
			
			<span  style="margin-left: 10px;"  v-show="record.status >1 " @click="() => onExports(record)"> <a
              href="javascript:;"
             
            >导出</a></span>
        <!-- </template> -->
        </template>
      </a-table>
    </div>
  </div>
</template>
<script>
import { servicecolumns ,yaoqicolumns} from './data/index';
import Utils from './utils/getStatus.js';
import TableSearch from './components/TableSearch';
export default {
  components: { TableSearch },
  // 状态获取
  filters: {
    agreement(val, role) {
      return Utils.getStatus(role, val);
    },
  },
  data() {
    return {
      selectData: [],
      columns:[],
      data: [],
      pageSize: 10,
      current: 1,
      total: 0,
      loading: true,
      hospitalVisible: false,
      title: '',
      operations: [],
	  token:''
    };
  },
  created() {
    this.$role = this.$store.state.user.role;
  },
  mounted() {
	  if (this.$store.state.user.role === 1) {
	    this.columns = servicecolumns;
	  } else {
	    this.columns = yaoqicolumns;
	  }
	  this.token = localStorage.getItem('token');
    // // 获取下拉框数据
    // this.getSelectData();
    // 获取表格数据
    this.getCompanyList()
  },
  methods: {
    // // 获取下拉框数据
    // async getSelectData() {
    //   let result = await this.$http.get('/mock/selectData');
    //   this.selectData = result.data;
    // },
	// 获取合作企业
	async getCompanyList() {
	  let result = await this.$http.post('/Company/getCooperationCompanyList');
	  if (result.data.status === 1) {
	    this.company_id=result.data.data.data_list[0].id
		// 获取表格数据
		this.getTableData({
		  keyword: this.keyword,
		  page: String(this.current),
		  pageSize: String(this.pageSize),
		   cooperation_company_id:  this.company_id
		});
	  }
	},
    // 获取表格数据
    async getTableData(params) {
      this.loading = true;
      let result = await this.$http.post('/WorkPlan/getList', params);
      if (result.data.status === 1) {
        this.loading = false;
        this.total = result.data.data.count;
        this.current = Number(params.page);
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            title: item.title,
            plan_start_time: this.$moment.unix(item.plan_start_time).format('YYYY-MM-DD'),
			      plan_end_time:this.$moment.unix(item.plan_end_time).format('YYYY-MM-DD'),
            qichacha_name:item.agreement_info.company_info.companyInfo.qichacha_name,
            create_time: item.create_time,
            work_plan_budget: item.work_plan_budget,
            province: item.agreement_info.province_txt,
            city: item.agreement_info.city_txt,
            status: item.status,
            operations: Utils.getOperation(
              this.$store.state.user.role,
              item.status,
            ),
			      chanpin: item.agreement_info.agreement_product.length?item.agreement_info.agreement_product[0].title:'无'
          };
          temp.push(obj);
        });
        this.data = temp;
      }
    },
	onChangecompany(value) {
	  this.current=1;
	  this.company_id=value;
	 this.getTableData(
	 
	   {   keyword: this.keyword,
        page: this.current,
        pageSize: String(this.pageSize),
		 cooperation_company_id:  this.company_id
	   });
	},
    // 搜索
    onSearch(value) {
      this.current=1;
      this.keyword = value;
      // 获取表格数据
      this.getTableData({
        keyword: this.keyword,
        page: this.current,
        pageSize: String(this.pageSize),
		    cooperation_company_id:  this.company_id
      });
    },
    // 新增
    editAndAdd() {
      this.$router.push('/plan/add?cooperation_company_id='+this.company_id);
    },
    // 操作
    action(record) {
      // 服务商
      if (this.$role === 1) {
        if (record.status === 0 || record.status === 2) {
          this.$router.push({
            path: '/plan/edit',
            query: { status: record.status, id: record.id ,cooperation_company_id:this.company_id},
          });
        } else {
          this.$router.push({
            path: '/plan/details',
            query: { status: record.status, id: record.id },
          });
        }
      } else {
        // 企业
        this.$router.push({
          path: '/plan/details',
          query: { status: record.status, id: record.id },
        });
      }
    },
    // 服务商提交
    async onConfirm(record) {
      let result = await this.$http.post('/WorkPlan/submit', {
        id: record.id,
      });
      if (result.data.status === 1) {
        this.getTableData({
          keyword: this.keyword,
          page: String(this.current),
          pageSize: String(this.pageSize),
		   cooperation_company_id:  this.company_id
        });
        this.$message.success('操作成功！');
      }
    },
	async onExport(company_id){
		window.location.href = `${this.uploadUrl}/WorkReport/exportWorkState?token=${this.token}&company_id=${company_id}`;
	   
	},
	onExports(record){
		window.location.href = `${this.uploadUrl}/WorkReport/exportWorkState?token=${this.token}&work_plan_id=${record.id}`;
	},
    // 删除
    onDelete(record) {
      // console.log('TCL: onDelete -> record', record);
    },
    // 分页
    changePage(pagination) {
      this.current=pagination.current;
      this.getTableData({
        keyword: this.keyword,
        page: String(pagination.current),
        pageSize: String(pagination.pageSize),
		 cooperation_company_id:  this.company_id
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.client-container {
}
</style>
